if (!customElements.get('highlight-modal')) {
  customElements.define('highlight-modal', class HighlightModal extends HTMLElement {
    constructor() {
      super();
      this.contentWrapper = this.querySelector('#HighlightModal-Content');
      this.closeButton = this.querySelector('.highlight-modal__close');
      this.overlay = this.querySelector('.highlight-modal__overlay');
      this.inner = this.querySelector('.highlight-modal__inner');

      this.posts = [];
      this.currentIndex = -1;

      this.previousButton =
      this.querySelector('.highlight-modal__previous');

      this.nextButton =
      this.querySelector('.highlight-modal__next');

      this.bindEvents();


    }

    bindEvents() {
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.close.bind(this));
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }
      this.addEventListener('click', (event) => {
        if (event.target === this) {
          this.close();
        }
      });
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
      if (this.inner) {
        this.inner.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }
      if(this.previousButton){

        this.previousButton.addEventListener(
          'click',
          ()=>this.previousPost()
        );
      
      }


      if(this.nextButton){

        this.nextButton.addEventListener(
          'click',
          ()=>this.nextPost()
        );
      }
    }

    loadPosts(){
      
      this.posts = Array.from(
        document.querySelectorAll(
          '#HighlightModalSources .highlight-modal-template'
        )
      );
    }

    open(template) {

      if (!template) return;

      // Clear previous content to prevent audio/video overlapping
      this.contentWrapper.innerHTML = '';
      // Clone and append new content
      const content = template.content.cloneNode(true);
      this.contentWrapper.appendChild(content);
      this.bindCaptionToggle();

      // Show modal and prevent body scroll
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');

      // Attempt to autoplay video if it exists in the modal
      const video = this.contentWrapper.querySelector('.highlight-modal__video');
      if (video) {
        video.play().catch((error) => {
          console.warn('Autoplay prevented by browser:', error);
        });
      }

      // Set focus to the modal for accessibility
      setTimeout(() => {
        this.contentWrapper.focus();
      }, 100);
    }

    openByHandle(handle){
      
      this.loadPosts();
      
      const index =
      this.posts.findIndex(template => {
        return (
          template.dataset.highlightHandle === handle
        );
      
      });

      if(index !== -1){

        this.currentIndex = index;

        this.open(
          this.posts[index]
        );

        this.updateNavigation();
      }
    }

    goToPost(index){

      if(
        index < 0 ||
        index >= this.posts.length
      ){
        return;
      }


      this.currentIndex = index;

      this.open(
        this.posts[index]
      );

      this.updateNavigation();
    
    }

    
    nextPost(){

      this.goToPost(
        this.currentIndex + 1
      );
    
    }


    previousPost(){

      this.goToPost(
        this.currentIndex - 1
      );
    
    }

    
    bindCaptionToggle() {


      const button = this.contentWrapper.querySelector('.caption-toggle');

      if (!button) return;
  
      const caption = this.contentWrapper.querySelector('.highlight-modal__caption');
  
      if (!caption) return;

  
      button.addEventListener('click', () => {
    
        caption.classList.toggle('is-expanded');
    
        const expanded = caption.classList.contains('is-expanded');

        button.textContent = expanded ? 'Less' : 'More';
    
        button.setAttribute(
          'aria-expanded',
          expanded
        );
  
      });

    }

    close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');

      // Pause video if playing
      const video = this.contentWrapper.querySelector('.highlight-modal__video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      
      // Delay clearing content to allow CSS opacity transition to finish
      setTimeout(() => {
        this.contentWrapper.innerHTML = '';
      }, 300); // Should match the CSS transition duration var(--duration-default)
    }

    updateNavigation(){
      
      console.log(
        'Navigation:',
        this.currentIndex,
        this.posts.length
      );

      if(!this.previousButton ||
        !this.nextButton){
          return;
        }
        this.previousButton.classList.toggle(
          'is-hidden',
          this.currentIndex <= 0
        );

        this.nextButton.classList.toggle(
          'is-hidden',
          this.currentIndex >= this.posts.length - 1
        );
      
      }
    });
  }

if (!customElements.get('highlight-card')) {
  customElements.define('highlight-card', class HighlightCard extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.highlight-card__trigger');
      this.video = this.querySelector('.highlight-card__video');
      
      this.bindEvents();
    }

    bindEvents() {
      if (!this.trigger) return;
      this.trigger.addEventListener('click', this.openModal.bind(this));
      if (!this.video) return;
      // Hover video (desktop only)
  
      if (window.matchMedia('(hover: hover)').matches) {
        this.trigger.addEventListener('mouseenter', async () => {
          try {
            await this.video.play();
            this.video.style.opacity = '1';
          } catch (e) {}
        });
        this.trigger.addEventListener('mouseleave', () => {
          this.video.pause();  
          this.video.currentTime = 0;
          this.video.style.opacity = '0';
        });
      }
    }

    openModal() {

      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
        this.video.style.opacity = '0';
      }

      const modal = document.querySelector('highlight-modal');
      const handle = this.dataset.highlightHandle;

      if (modal && handle) {
        modal.openByHandle(handle);
      }

    }

  });
}

document.querySelectorAll('.product-community__trigger').forEach(trigger => {

  trigger.addEventListener('click', () => {

    const modal = document.querySelector('highlight-modal');

    const handle = trigger.dataset.highlightHandle;

    if (modal && handle) {
      modal.openByHandle(handle);
    }

  });

});

class ProductCommunity {

  constructor(section) {

    this.section = section;

    this.items = Array.from(
      section.querySelectorAll('.product-community__content')
    );

    this.previousButton =
      section.querySelector('.product-community__prev');

    this.nextButton =
      section.querySelector('.product-community__next');


    this.currentIndex = 0;


    this.bindEvents();

    this.update();

  }


  bindEvents() {

    if (this.previousButton) {

      this.previousButton.addEventListener(
        'click',
        () => {
          this.previous();
        }
      );

    }


    if (this.nextButton) {

      this.nextButton.addEventListener(
        'click',
        () => {
          this.next();
        }
      );

    }

  }


update() {


    this.items.forEach((item, index) => {


      item.classList.toggle(
        'is-active',
        index === this.currentIndex
      );


      const video = item.querySelector(
        '.product-community__video'
      );


      if(video && index !== this.currentIndex){

        video.pause();

        video.currentTime = 0;

      }


    });


    if (this.previousButton) {

      this.previousButton.classList.toggle(
        'is-hidden',
        this.currentIndex === 0
      );

    }


    if (this.nextButton) {

      this.nextButton.classList.toggle(
        'is-hidden',
        this.currentIndex === this.items.length - 1
      );

    }


  }


  next() {

    if (
      this.currentIndex >= this.items.length - 1
    ) {
      return;
    }


    this.currentIndex++;

    this.update();

  }


  previous() {

    if (
      this.currentIndex <= 0
    ) {
      return;
    }


    this.currentIndex--;

    this.update();

  }

}


document
  .querySelectorAll('.product-community')
  .forEach(section => {

    new ProductCommunity(section);

  });
